define([
    "models/system/systemFunctions",
    "models/portalUser",
    "helpers/modalWindowsMaintainer",
    "models/system/datasource"
], function (sysFunc, user, modalWindowsMaintainer) {

    function CommonView(dataSource, canUpdate, canSelect, canInsert) {
        this.dataSource = dataSource;
        this.canDelete = true;
        this.canUpdate = (canUpdate ? canUpdate : dataSource.model.canUpdate);
        this.canSelect = (canSelect ? canSelect : dataSource.model.canSelect);
        this.canInsert = (canInsert ? canInsert : dataSource.model.canInsert);
        this._defaultFilter = [{id: 0, value: APPLOCALE.messages.msgWait, disabled: true}];
        this._insertFormCode = {};
        this._updateFormCode = {};
        this._insertForm = null;
        this._insertWindowId = null;
        this._updateWindowId = null;
        this._insertFormId = null;
        this._updateFormId = null;
        this._updateForm = null;
        this._formCreationValues = null;
        this._gridCode = null;
        this._gridTasks = {};
        this._formTasks = {};

        this.currentElement = null; // текущий элемент формы, куда производится ввод

        this._gridId = "grid" + dataSource.model._modelName;

        // this.isViewInitialized = {};
        // this.viewDataCollections = {};

        this._insertWindowId = "insertWindow" + dataSource.model._modelName;
        this._insertFormId = "insertForm" + dataSource.model._modelName;
        this._updateWindowId = "updateWindow" + dataSource.model._modelName;
        this._updateFormId = "updateForm" + dataSource.model._modelName;
    }

    /**
     * Функции для формирования и кеширования очереди заданий таблиц и форм
     */

    CommonView.prototype.initTaskSequence = function (viewId, type, force, noSectionLink) {
        var key = "_" + type + "Tasks";
        var taskKey = viewId;
        if (!noSectionLink) {
            taskKey += "_" + sysFunc.getCurrentSection();
        }
        if (typeof this[key][viewId + "_" + sysFunc.getCurrentSection()] === 'undefined' || force) {
            this[key][taskKey] = [];
            this[key][taskKey + "_stackIsFull"] = false;
        }
    };

    CommonView.prototype.pushNewTask = function (viewId, arTask, type, noSectionLink) {
        var key = "_" + type + "Tasks";
        var taskKey = viewId;
        if (!noSectionLink) {
            taskKey += "_" + sysFunc.getCurrentSection();
        }
        this[key][taskKey].push(arTask);
    };

    CommonView.prototype.getTaskSequence = function (viewId, type, noSectionLink) {
        var key = "_" + type + "Tasks";
        var taskKey = viewId;
        if (!noSectionLink) {
            taskKey += "_" + sysFunc.getCurrentSection();
        }
        return this[key][taskKey];
    };

    CommonView.prototype.closeTaskSequence = function (viewId, type, noSectionLink) {
        var key = "_" + type + "Tasks";
        var taskKey = viewId;
        if (!noSectionLink) {
            taskKey += "_" + sysFunc.getCurrentSection();
        }
        this[key][taskKey + "_stackIsFull"] = true;
    };

    CommonView.prototype.isCurrentSectionSequenceFull = function (viewId, type, noSectionLink) {
        var key = "_" + type + "Tasks";
        var taskKey = viewId;
        if (!noSectionLink) {
            taskKey += "_" + sysFunc.getCurrentSection();
        }
        return this[key][taskKey + "_stackIsFull"];
    };

    /**
     * Функция формирования заданий для загрузки коллекций данных
     * @param field
     * @param viewId
     * @param type
     */
    CommonView.prototype.makeTask = function (field, viewId, type) {
        var collection = null,
            taskJson = null;

        switch (field.type) {
            case "dictionary":
                taskJson = {
                    task: "loadDictionary",
                    field: field
                };
                taskJson[type + "Id"] = viewId;
                collection = new webix.DataCollection({
                    data: this._defaultFilter
                });
                break;
            case "toggle":
                taskJson = {
                    task: "loadToggle",
                    field: field
                };
                taskJson[type + "Id"] = viewId;
                collection = new webix.DataCollection({
                    data: this._defaultFilter
                });
                break;
            case "exception":
                this.initTaskSequence(viewId, type);
                break;
        }
        return {
            collection: collection,
            task: taskJson
        };
    };

    // dirty hack to fix Webix bug of column filter focus loose when data filtering occurs
    // iterating over grid columns and binding focus saver to focus event
    CommonView.prototype.saveActiveFilter = function(grid) {
        grid.eachColumn(function(t, i) {
            var f = this.getFilter(t);
            if (f) {
                webix.event(f, "focus", webix.bind(function(e) {
                    grid.$activeFilter = t;
                }, grid));
            }
        });
    };

    // dirty hack to fix Webix bug of column filter focus loose when data filtering occurs
    // set focus into active filter
    CommonView.prototype.restoreActiveFilterFocus = function(grid) {
        if (grid.$activeFilter){
            var f = grid.getFilter(grid.$activeFilter);
            f.focus();
            // grid.$activeFilter = null;
        }
    };

    /**
     * Описываем создание таблицы
     * @param paramsTable
     * @param paramsField
     * @param userLevel
     * @param canDelete
     * @param inLineEdit
     * @param noSectionLink - если структуру полей таблицы не нужно привязывать к разделу (одинаковая во всех разделах)
     */
    CommonView.prototype.getTable = function (paramsTable, paramsField, userLevel, canDelete, inLineEdit, noSectionLink) {
        var self = this;
        if (!userLevel)
            userLevel = 4;

        if (paramsTable && paramsTable.id) {
            this._gridId = paramsTable.id;
        }

        this.initTaskSequence(this._gridId, "grid", false, noSectionLink);

        /**
         * Формируем записи, на основание переданных филдов
         * @type {Array}
         */

        var visibleFields = [];
        this.dataSource.model.fields.forEach(function (field, index) {
            if (field.showInGrid) {
                if (userLevel && userLevel < field.viewLevel)
                    return;

                var gridColumn = {
                    id: field.name,
                    name: field.name,
                    map: field.map,
                    header: field.header,
                    fillspace: field.fillspace,
                    adjust: field.adjust,
                    sort: field.sort,
                    hidden: field.hidden,
                    template: field.template,
                    type: field.type,
                    width: field.width,
                    minWidth: field.minWidth
                };

                switch (gridColumn.type) {
                    case "dictionary":
                        gridColumn.dictionaryName = field.dictionaryName;
                        break;
                    case "toggle":
                        gridColumn.toggleName = field.toggleName;
                        break;
                }
                // если кастомные параметры полей заданы, сразу не добавляем задачи так как поля могут
                // кастомизироваться и быть скрыты, поэтому задачи добавим на этапе завершения кастомизации полей
                // если кастомные параметры полей не заданы и очередь заданий для таблицы в текущем разделе приложения
                // ещё не сформирована, сразу добавляем задачи для видимых полей
                if (!paramsField && !self.isCurrentSectionSequenceFull(self._gridId, "grid", noSectionLink)) {
                    if (field.hidden !== true) {
                        var colConfig = self.makeTask(gridColumn, self._gridId, "grid");
                        // console.log(colConfig);
                        if (colConfig.task) {
                            self.pushNewTask(self._gridId, colConfig.task, "grid", noSectionLink);
                            gridColumn.collection = colConfig.collection;
                        }
                    }
                    delete gridColumn.type;
                }

                if (inLineEdit && field.editor) {
                    gridColumn.editor = field.editor;
                }
                visibleFields.push(gridColumn);
            }
            if (!paramsField && index === self.dataSource.model.fields.length - 1) {
                self.closeTaskSequence(self._gridId, "grid", noSectionLink);
            }
        });

        if (paramsField) {
            var addTableTasks = false;
            paramsField.forEach(function (element, index) {
                var isNewColumn = true;
                if (index === paramsField.length - 1) {
                    addTableTasks = true;
                }
                visibleFields.forEach(function (field, fieldIndex) {
                    if (element.id === field.id) {
                        for (var key in element) {
                            if (element.hasOwnProperty(key))
                                field[key] = element[key];
                        }
                        isNewColumn = false;
                    }
                    // на последнем шаге цикла по кастомным полям (когда исходые поля таблицы уже модифицированы)
                    // добавляем задачи для видимых полей
                    if (addTableTasks) {
                        if (field.hidden !== true) {
                            var colConfig = self.makeTask(field, self._gridId, "grid");
                            if (colConfig.task && !self.isCurrentSectionSequenceFull(self._gridId, "grid", noSectionLink)) {
                                self.pushNewTask(self._gridId, colConfig.task, "grid", noSectionLink);
                                field.collection = colConfig.collection;
                            }
                            delete field.type;
                            // delete field.name;

                        }
                        if (fieldIndex === visibleFields.length - 1) {
                            self.closeTaskSequence(self._gridId, "grid", noSectionLink);
                        }
                    }
                });
                if (isNewColumn) {
                    if (typeof element.index !== 'undefined') {
                        var indexField = Number(element.index);
                        // delete field.index;
                        visibleFields.splice(indexField, 0, element);
                    }
                    else
                        visibleFields.push(element);
                }
            });
        }

        /**
         * Добавляем возможность удаления записи
         */
        if (userLevel && userLevel >= this.dataSource.model.deleteLevel) {
            if (canDelete) {
                visibleFields.push({
                    id: "trash",
                    header: "&nbsp;",
                    width: 40,
                    tooltip: APPLOCALE.grid.trash,
                    template: "<span style='color:#777777; cursor:pointer;' class='webix_icon far fa-trash-alt'></span>"
                });
            }
        }

        var gridCode = {
            view: "datatable",
            id: this._gridId,
            scroll: "xy",
            select: "row",
            datafetch: 40,
            datathrottle: 80,
            loadahead: 50,
            resizeColumn: true,
            tooltip: true,
            url: API_URL + "get" + this.dataSource.model.url,
            on: {
                onHeaderClick: function () {
                    if (this.getEditor())
                        return false;
                },
                onLoadError: function (text, xml, xhr) {
                    self.dataSource.actionOnErrorAjax(text, xml, xhr);
                },
                onBeforeLoad: function () {
                    if (this)
                        this.showOverlay(APPLOCALE.messages.msgLoading);
                },
                onAfterLoad: function () {
                    if (this)
                        this.hideOverlay();
                    var row_id = this.getFirstId();
                    if (!row_id)
                        this.showOverlay(APPLOCALE.messages.msgNullRecords);
                    this.eachColumn(function(colId) {
                        var colConfig = this.getColumnConfig(colId);
                        var adjust = colConfig.adjust === true ? "all" : colConfig.adjust;
                        if (adjust && !colConfig.fillspace && !colConfig.width) {
                            this.adjustColumn(colId);
                        }
                    });
                    self.restoreActiveFilterFocus(this);
                },
                onAfterAdd: function () {
                    this.hideOverlay();
                },
                onAfterDelete: function () {
                    if (this.count() === 0)
                        this.showOverlay(APPLOCALE.messages.msgNullRecords);
                },
                onAfterFilter: function () {
                    if (this.getFirstId())
                        this.hideOverlay();
                    else
                        this.showOverlay(APPLOCALE.messages.msgNullRecords);
                    self.restoreActiveFilterFocus(this);
                },
                onAfterRender: function () {
                    self.saveActiveFilter(this);
                }
            },
            onClick: {
                webix_icon: function (e, id, node) {
                    if (paramsTable && paramsTable._actionClick) {
                        return paramsTable._actionClick(e, id, node, self);
                    } else return self.onDeleteIconClick(e, id, node, self);
                }
            },
            scheme: {},
            columns: visibleFields,
            rules: this.dataSource.model.rules
        };
        // console.log(gridCode);

        /**
         * Обрабатываем параметры, которые задал пользователь
         */
        if (paramsTable) {
            for (var key in paramsTable) {
                if (key === "on" || key === "scheme") { 
                    var curKey = paramsTable[key];
                    var gridKey = gridCode[key];
                    for (var keyInner in curKey) {
                        gridKey[keyInner] = curKey[keyInner];
                    }
                } else
                    gridCode[key] = paramsTable[key];
            }
        }
        return gridCode;
    };

    CommonView.prototype.onDeleteIconClick = function (e, id, node, self) {
        webix.confirm({
            text: APPLOCALE.messages.msgWillBeDelet,
            ok: APPLOCALE.button.btnYes,
            cancel: APPLOCALE.button.btnCancel,
            callback: function (res) {
                if (res) {
                    $$('mainLayout').showProgress({});
                    var curTable = $$(self._gridId);
                    var curItem = curTable.getItem(id);

                    self.dataSource.deleteRecord(curItem, function (response, record) {
                        curTable.remove(curItem.id);
                        curTable.refresh();
                        $$('mainLayout').hideProgress({});
                    });
                }
            }
        });
    };

    CommonView.prototype.onInsertButtonClick = function (self, button) {
        var form = $$(self._insertFormId),
            window = $$(self._insertWindowId),
            values = form.getValues(),
            curTable = $$(self._gridId),
            isSuccess = false;
        webix.extend(window, webix.ProgressBar);

        if (form.validate()) {
            window.showProgress({});
            self.dataSource.insertRecord(values, function (response, insRecord) {
                curTable.add(response.data);
                curTable.refresh();
                isSuccess = true;
                window.hideProgress();
                window.close();
            }, function (e) {
                console.error(e);
                window.hideProgress();
                button.enable();
            });
        } else {
            webix.message(APPLOCALE.messages.msgCheckFields);
            button.enable();
        }
        return isSuccess;
    };

    CommonView.prototype.buildFormElements = function (paramsElement, viewId, userLevel, customFields, noCache) {
        // инициализируем очередь задач
        this.initTaskSequence(viewId, "form", noCache);

        var visibleElements = [],
            self = this,
            initialFields;

        if (customFields)
            initialFields = customFields;
        else
            initialFields = this.dataSource.model.fields;

        initialFields.forEach(function (field, index) {
            if (field.showInForm) {
                if (userLevel && userLevel < field.viewLevel)
                    return;

                var formField = {
                    name: field.name,
                    label: field.label,
                    invalidMessage: field.invalidMessage,
                    required: field.required,
                    view: field.view,
                    id: field.id,
                    disabled: field.disabled,
                    hidden: field.hidden,
                    checkValue: field.checkValue,
                    uncheckValue: field.uncheckValue,
                    options: field.options,
                    on: field.on,
                    type: field.type,
                    css: field.css
                };

                // кастомная ширина лэйбла
                if (field.labelWidth)
                    formField.labelWidth = field.labelWidth;

                switch (formField.type) {
                    case "dictionary":
                        formField.dictionaryName = field.dictionaryName;
                        break;
                    case "toggle":
                        formField.toggleName = field.toggleName;
                        break;
                }

                // если кастомные параметры полей заданы, сразу не добавляем задачи так как поля могут
                // кастомизироваться и быть скрыты, поэтому задачи добавим на этапе завершения кастомизации полей
                // если кастомные параметры полей не заданы и очередь заданий для формы в текущем разделе приложения
                // ещё не сформирована, сразу добавляем задачи для видимых полей
                if (!paramsElement && !self.isCurrentSectionSequenceFull(viewId, "form")) {
                    if (field.hidden !== true && (field.type === "toggle" || field.type === "dictionary")) {
                        var fieldConfig = self.makeTask(formField, viewId, "form");
                        if (fieldConfig.task) {
                            self.pushNewTask(viewId, fieldConfig.task, "form");
                            formField.collection = fieldConfig.collection;
                        }
                    }
                }

                // подключаем валидацию на лету для текстовых элементов
                if (self.dataSource.model.rules[formField.name]) {
                    formField.validate = self.dataSource.model.rules[formField.name];
                    // валидация текстового элемента на лету
                    if (formField.view === "text") {
                        formField.keyPressTimeout = 500;
                        formField.validateEvent = "key";
                        formField.on = {
                            onBeforeRender: function () {
                                if (self.currentElement)
                                    self.currentElement.value = this.getValue();
                            },
                            onAfterRender: function () {
                                if (self.currentElement && this.config.id === self.currentElement.id) {
                                    this.setValue(self.currentElement.value);
                                    this.focus();
                                    webix.html.setSelectionRange(this.getInputNode(), self.currentElement.pos);
                                }
                            },
                            onTimedKeyPress: function () {
                                self.currentElement = {id: this.config.id};
                                self.currentElement.pos = webix.html.getSelectionRange(this.getInputNode()).start;
                            }
                        };
                    }
                }

                visibleElements.push(formField);
            }
            if (!paramsElement && index === initialFields.length - 1) {
                self.closeTaskSequence(viewId, "form");
            }
        });

        if (paramsElement) {
            var addFormTasks = false;
            paramsElement.forEach(function (element, index) {
                if (index === paramsElement.length - 1) {
                    addFormTasks = true;
                }
                var isNewField = true;
                visibleElements.forEach(function (field, fieldIndex) {
                    if (element.name && element.name === field.name) {
                        if (element.view !== "text" && field.view === "text" && !!field.on) {
                            delete field.validateEvent;
                            delete field.keyPressTimeout;
                            delete field.on;
                        }
                        for (var key in element) {
                            field[key] = element[key];
                        }
                        isNewField = false;
                    }
                    // на последнем шаге цикла по кастомным полям (когда исходые поля формы уже модифицированы)
                    // добавляем задачи для видимых полей
                    if (addFormTasks) {
                        if (field.hidden !== true && (field.type === "toggle" || field.type === "dictionary")) {
                            var fieldConfig = self.makeTask(field, viewId, "form");
                            if (fieldConfig.task && !self.isCurrentSectionSequenceFull(viewId, "form")) {
                                self.pushNewTask(viewId, fieldConfig.task, "form");
                                field.collection = fieldConfig.collection;
                            }
                        }
                        if (fieldIndex === visibleElements.length - 1) {
                            self.closeTaskSequence(viewId, "form");
                        }
                    }
                });
                if (isNewField) {
                    if (typeof element.index !== 'undefined') {
                        var indexField = Number(element.index);
                        // delete element.index;
                        visibleElements.splice(indexField, 0, element);
                    }
                    else {
                        visibleElements.push(element);
                    }
                }
            });
        }
        return visibleElements;
    };

    /**
     * Отображаем форму для добавления
     * @param values object
     * @param params object
     * @param paramsElement object
     * @param userLevel number
     */
    CommonView.prototype.showInsertForm = function (values, params, paramsElement, userLevel) {
        this._formCreationValues = values;
        if (!userLevel)
            userLevel = 6;
        if (userLevel < this.dataSource.model.insertLevel) {
            console.error("User level is too low");
            return;
        }

        this._prepareInsertForm(params, paramsElement, userLevel);
        this._insertForm.show();
        modalWindowsMaintainer.registerModalView(this._insertForm);

        if ($$(this._insertWindowId) && values)
            $$(this._insertFormId).setValues(values);
    };

    /**
     * Создаём форму для добавления сущности
     * @param params object
     * @param paramsElement object
     * @param userLevel number
     */
    CommonView.prototype._prepareInsertForm = function (params, paramsElement, userLevel, initialFields, noCache) {
        var self = this;
        var sectionId = sysFunc.getCurrentSection();

        if (!this._insertFormCode[sectionId] || noCache) {
            if (!userLevel)
                userLevel = 6;

            if (userLevel < this.dataSource.model.insertLevel) {
                console.error("User rights level is too low");
                return;
            }

            var visibleElements = this.buildFormElements(paramsElement, this._insertFormId, userLevel, noCache);

            var additionalButtons = [];

            if (params.formButtons && params.formButtons.length) {
                params.formButtons.forEach(function (elem) {
                    additionalButtons.push(elem);
                });
            }
            additionalButtons.push({});

            var stackedButtons = !!(params && params.stackedButtons);
            var insertButtonClick = function () {
                this.disable();
                var thisForm = this.getFormView();
                var formData = thisForm.getValues();
                Object.keys(formData).forEach(function (key) {
                    // исправление если кнопки исчезают после отправки формы.
                    if (typeof formData[key] === "string") {
                        if (key.startsWith("button") || key.startsWith("buton")) {
                            formData[key] = thisForm.elements[key].data.label || "";
                        } else {
                            formData[key] = formData[key].trim();
                        }
                    }
                });
                thisForm.setValues(formData);
                if (params && params._actionClick) {
                    return params._actionClick(self, this);
                } else return self.onInsertButtonClick(self, this);
            };
            var insertButton = {
                view: "button",
                name: "buttonInsert",
                id: params && params._addBtnId ? params._addBtnId : "buttonInsert",
                label: params && params._addBtnLabel ? params._addBtnLabel : APPLOCALE.button.btnAdd,
                align: "center",
                width: stackedButtons ? 0 : 150,
                click: insertButtonClick
            };
            var cancelButton = {
                view: "button",
                name: "buttonCancel",
                hidden: params && params._isSlave,
                label: APPLOCALE.button.btnCancel,
                align: "center",
                width: stackedButtons ? 0 : 150,
                click: function () {
                    $$(self._insertWindowId).close();
                }
            };
            var controlButtons;
            if (stackedButtons) {
                insertButton.gravity = 1;
                cancelButton.gravity = 1;
                var stackedRows = [insertButton];
                if (!(params && params._isSlave)) {
                    stackedRows.push({height: 6});
                    stackedRows.push(cancelButton);
                }
                if (params.formButtons && params.formButtons.length) {
                    params.formButtons.forEach(function (elem) {
                        var btn = elem;
                        if (btn && btn.view === "button") {
                            btn.width = 0;
                            btn.gravity = 1;
                        }
                        stackedRows.push({height: 6});
                        stackedRows.push(btn);
                    });
                }
                var stackedBtnCount = stackedRows.filter(function (row) {
                    return row && row.view === "button";
                }).length;
                controlButtons = {
                    // фиксированная высота: при invalidMessage поля растут,
                    // без неё кнопки сжимаются; scrollview не используем (ломает остальные формы)
                    id: this._insertFormId + "ControlButtons",
                    height: stackedBtnCount * 38 + Math.max(0, stackedBtnCount - 1) * 6,
                    margin: 0,
                    rows: stackedRows
                };
            } else {
                controlButtons = {
                    id: this._insertFormId + "ControlButtons",
                    height: 38,
                    margin: 10,
                    cols: [{}, insertButton, cancelButton].concat(additionalButtons)
                };
            }

            this._insertFormCode[sectionId] = {
                view: "window",
                modal: true,
                id: this._insertWindowId,
                position: "center",
                head: APPLOCALE.grid.add,
                body: {
                    paddingY: 20,
                    paddingX: 30,
                    elementsConfig: {
                        labelWidth: 200
                    },
                    view: "form",
                    width: params.width || 600,
                    id: this._insertFormId,
                    // rules: self.dataSource.model.rules,
                    elements: [
                        {
                            id: this._insertFormId + "Elements",
                            rows: visibleElements
                        },
                        {height: 20},
                        controlButtons
                    ]
                },
                on: {
                    onDestruct: function () {
                        modalWindowsMaintainer.removeModalViews(this.config.id, false);
                    }
                }
            };

            if (params) {
                for (var key in params) {
                    if (key === "body") {
                        var curKey = params[key];
                        var formKey = this._insertFormCode[sectionId][key];
                        for (var keyInner in curKey) {
                            /*if (keyInner === "elements") {
                                insertElements(curKey[keyInner], formKey[keyInner]);
                            } else */
                            formKey[keyInner] = curKey[keyInner];
                        }
                    } else if (key !== "stackedButtons")
                        this._insertFormCode[sectionId][key] = params[key];
                }
                // params.body.type - ключ, определяющий показывается ли форма внутри родительского элемента; если, да: значение 'inner"
                if (params.body && params.body.type === 'inner') {
                    this._insertFormCode[sectionId].rows = [];
                    this._insertFormCode[sectionId].rows[0] = this._insertFormCode[sectionId].body;
                    delete this._insertFormCode[sectionId].rows[0].type;
                    delete this._insertFormCode[sectionId].head;
                    delete this._insertFormCode[sectionId].position;
                    delete this._insertFormCode[sectionId].modal;
                    delete this._insertFormCode[sectionId].body;
                }
            }
        }

        // params.body.parent - ключ, определяющий родительский элемент для вставки в него формы
        if (params.body && params.body.parent) {
            this._insertForm = webix.ui(this._insertFormCode[sectionId], params.body.parent);
        }
        else {
            this._insertForm = webix.ui(this._insertFormCode[sectionId]);
        }
    };

    CommonView.prototype.initializeInsForm = function (noCache) {
        var formTasks = this.getTaskSequence(this._insertFormId, "form");
        if (formTasks.length > 0 || noCache) {
            webix.extend($$(this._insertWindowId), webix.ProgressBar);
            $$(this._insertWindowId).showProgress({});
            return formTasks;
        }
        return false;
    };

    CommonView.prototype.onUpdateButtonClick = function (self, button) {
        var form = $$(this._updateFormId),
            window = $$(self._updateWindowId),
            values = form.getValues(),
            curTable = $$(self._gridId),
            isSuccess = false;
        webix.extend(window, webix.ProgressBar);

        if (form.validate()) {
            window.showProgress({});
            self.dataSource.updateRecord(values, function (response, updRecord) {
                curTable.updateItem(values.id, response.data);
                curTable.refresh();
                isSuccess = true;
                window.hideProgress();
                window.close();
            }, function (e) {
                console.error(e);
                button.enable();
                window.hideProgress();
            });
        } else {
            webix.message(APPLOCALE.messages.msgCheckFields);
            button.enable();
        }
        return isSuccess;
    };

    /**
     * Отображаем форму для обновления
     * @param values
     * @param params
     * @param paramsElement
     * @param userLevel
     */
    CommonView.prototype.showUpdateForm = function (values, params, paramsElement, userLevel, initialFields, noCache) {
        var self = this;
        this._formCreationValues = values;
        if (!userLevel)
            userLevel = 6;
        if (userLevel < this.dataSource.model.updateLevel) {
            console.error("User level is too low");
            return;
        }

        this._prepareUpdateForm(params, paramsElement, userLevel, initialFields, noCache);
        this._updateForm.show();
        modalWindowsMaintainer.registerModalView(this._updateForm);

        if ($$(this._updateWindowId) && values)
            $$(this._updateFormId).setValues(values);
    };

    /**
     * Формируем форму для обновления
     * @param params
     * @param paramsElement
     * @param userLevel
     */
    CommonView.prototype._prepareUpdateForm = function (params, paramsElement, userLevel, initialFields, noCache) {
        var self = this;
        var sectionId = sysFunc.getCurrentSection();
        if (!this._updateFormCode[sectionId] || noCache) {
            if (!userLevel)
                userLevel = 6;

            if (userLevel < this.dataSource.model.updateLevel) {
                console.error("User level is too low");
                return;
            }

            var formFields;
            if (initialFields) {
                formFields = initialFields;
            } else {
                formFields = this.dataSource.model.fields;
            }

            var visibleElements = this.buildFormElements(paramsElement, this._updateFormId, userLevel, formFields, noCache);

            this._updateFormCode[sectionId] = {
                view: "window",
                modal: true,
                id: this._updateWindowId,
                position: "center",
                head: APPLOCALE.grid.renew,
                body: {
                    paddingY: 20,
                    paddingX: 30,
                    elementsConfig: {
                        labelWidth: 200
                    },
                    view: "form",
                    width: params.width || 600,
                    id: this._updateFormId,
                    // rules: this.dataSource.model.rules,
                    elements: [
                        {rows: visibleElements},
                        {height: 20},
                        {
                            margin: 10,
                            cols: [
                                {}, {
                                    view: "button",
                                    name: "buttonUpdate",
                                    label: APPLOCALE.button.btnChg,
                                    align: "center",
                                    width: 150,
                                    click: function () {
                                        this.disable();
                                        if (params && params._actionClick) {
                                            return params._actionClick(self, this);
                                        } else return self.onUpdateButtonClick(self, this);
                                    }
                                }, {
                                    view: "button",
                                    name: "buttonCancel",
                                    label: APPLOCALE.button.btnCancel,
                                    align: "center",
                                    width: 150,
                                    click: function () {
                                        $$(self._updateWindowId).close();
                                    }
                                }, {}
                            ]
                        }
                    ]

                },
                on: {
                    onDestruct: function () {
                        modalWindowsMaintainer.removeModalViews(this.config.id, false);
                    }
                }
            };

            if (params) {
                for (var key in params) {
                    if (key === "body") {
                        var curKey = params[key];
                        var formKey = this._updateFormCode[sectionId][key];
                        for (var keyInner in curKey) {
                            formKey[keyInner] = curKey[keyInner];
                        }
                    } else
                        this._updateFormCode[sectionId][key] = params[key];
                }
            }
        }
        if (!$$(this._updateWindowId)) {
            this._updateForm = webix.ui(this._updateFormCode[sectionId]);
        }
    };

    CommonView.prototype.initializeUpdForm = function (noCache) {
        var formTasks = this.getTaskSequence(this._updateFormId, "form");
        if (formTasks.length > 0 || noCache) {
            webix.extend($$(this._updateWindowId), webix.ProgressBar);
            $$(this._updateWindowId).showProgress({});
            return formTasks;
        }
        return false;
    };

    /**
     * Обрабатываем toggle и dictionary, то есть автозамену данных в таблице
     */
    CommonView.prototype.initializeTable = function (gridId, noSectionLink) {
        if (gridId) {
            return this.getTaskSequence(gridId, "grid", noSectionLink);
        } else {
            return this.getTaskSequence(this._gridId, "grid", noSectionLink);
        }
    };

    /**
     * Добавление(загрузка) данных в зависимую таблицу
     * @param filters
     * @param sort
     * @param isSlave
     * @returns {*}
     */
    CommonView.prototype.getDataCollectionDefinition = function (filters, sort, isSlave, endPoint, countRecords, custom) {
        var self = this;

        if (isSlave) {

            return {
                dataFeed: self.dataSource.getDataCollectionDefinition(filters),
                on: {
                    onLoadError: function (text, xml, xhr) {
                        self.dataSource.actionOnErrorAjax(text, xml, xhr);
                    },
                    onBeforeLoad: function () {
                        if ($$(self._gridId))
                            $$(self._gridId).showOverlay(APPLOCALE.messages.msgLoading);
                    },
                    onAfterLoad: function () {
                        if ($$(self._gridId))
                            $$(self._gridId).hideOverlay();
                        var row_id = $$(self._gridId).getFirstId();
                        if (!row_id)
                            $$(self._gridId).showOverlay(APPLOCALE.messages.msgNullRecords);
                    }
                }
            };
        }
        return {

            url: self.dataSource.getDataCollectionDefinition(filters, endPoint, custom),
            on: {
                onLoadError: function (text, xml, xhr) {
                    self.dataSource.actionOnErrorAjax(text, xml, xhr);
                },
                onBeforeLoad: function () {
                    if ($$(self._gridId))
                        $$(self._gridId).showOverlay(APPLOCALE.messages.msgLoading);
                },
                onAfterLoad: function () {
                    if ($$(self._gridId))
                        $$(self._gridId).hideOverlay();
                    var row_id = $$(self._gridId).getFirstId();
                    if (!row_id)
                        $$(self._gridId).showOverlay(APPLOCALE.messages.msgNullRecords);
                    if (countRecords) {
                        countRecords(self);
                    }
                    if (sort)
                        this.sort(sort.by, sort.order, sort.as);
                }
            }
        };
    };

    /**
     * Функция для проверки всех значений редактируемой строки, результат boolean
     * @param curTable
     * @param editor
     * @param state
     * @param ignore
     * @returns {boolean}
     */
    CommonView.prototype.validateCurrentRowGrid = function (curTable, editor, state, ignore) {
        var self = this;

        // ignore is true when editing is escaped
        if (ignore) {
            curTable.editCancel();
            return false;
        } else {
            var key = editor.column,
                rules = self.dataSource.model.rules,
                curRule = rules[key],
                testValue = state.value;

            // если правило валидации не обнаружено
            if (typeof curRule === 'undefined') {
                if (!!rules.$obj) {
                    curRule = rules.$obj;
                    testValue = curTable.getItem(editor.row);
                } else
                    return true;
            }

            var check = curRule(testValue);

            //  alert custom column message
            if (!check && testValue === state.value) {
                var invalidMessage = "";
                self.dataSource.model.fields.forEach(function (field) {
                    if (field.name === key) {
                        invalidMessage = field.invalidMessage;
                    }
                });
                webix.message({type: "error", text: editor.config.header[0].text + ": " + invalidMessage});
                return false;
            }
            return true;
        }
    };

    return CommonView;
});
